import Modal from '@/components/Modal';
import { useGetVehiculeCheckVideo } from '@/hooks/vehicule-check-result.hooks';
import { RefObject } from 'react';
import DetectionVideoPlayer from '@/modules/VehiculeCheckResult/components/DetectionVideoPlayer';
import '../styles.css';
import { TFunction } from 'i18next';
import { R2_PUBLIC_DOMAIN } from '@/utils/constant.utils';

interface DetectionModalProps {
  t: TFunction<undefined>;
  vehiculeCheckId?: string;
  videoRef?: RefObject<HTMLVideoElement>;
}

export const DetectionModal = ({
  t,
  vehiculeCheckId,
  videoRef,
}: DetectionModalProps) => {
  // const videoUrl = '/video_result.mp4';
  const { videoUrl, isLoading: isLoadingVideo } =
    useGetVehiculeCheckVideo(vehiculeCheckId);

  const stopVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <Modal
      id="view-detection-modal"
      title={t('completeInspection')}
      showCancelBtn={false}
      showSecondBtn={false}
      showFooter={false}
      onClose={() => {
        stopVideo();
      }}
      size="medium"
      headerClassName="result-modal-header"
      bodyClassName="px-6 pt-2.5 pb-5 m-0"
    >
      <DetectionVideoPlayer
        t={t}
        videoRef={videoRef}
        videoUrl={videoUrl}
        isLoadingVideo={isLoadingVideo}
        videoContainerClassName="h-[50vh]"
        detectionFiles={{
          damagesUrl: `${R2_PUBLIC_DOMAIN}/videos/${vehiculeCheckId}-damage.txt`,
          detectionsUrl: `${R2_PUBLIC_DOMAIN}/videos/${vehiculeCheckId}-detection.txt`,
        }}
      />
      {/* <div data-modal-persistent="true" className="mt-6 flex justify-center">
        <Button
          text="Capturer l'image"
          textClassName="text-sm text-purple-5433FF"
          leftIcon={
            <FrameIcon className="w-6 h-6 [&>path]:fill-purple-5433FF" />
          }
          onClick={() => {
            setVideoCurrentTime(videoRef.current?.currentTime);
          }}
          buttonClassName="result-modal-button w-full bg-white max-w-[310px]"
        />
      </div> */}
    </Modal>
  );
};
